<template>
	<th v-bind:id="'column-' + column.id">
		{{column.name}}
		<button v-if="column.isSortable"
				v-on:click="onColumnSortable(column)"
				class="sortable-button">
			<i v-if="column.isSortable.down"
			class="sortable-icon material-icons icon">arrow_drop_down</i>
			<i v-if="column.isSortable.up"
			class="sortable-icon material-icons icon">arrow_drop_up</i>
		</button>
	</th>
</template>

<script>

const SORTABLE_COLUMN_EVENT = 'on-column-sortable';

function onColumnSortable(column) {
	this.$emit(SORTABLE_COLUMN_EVENT, column);
}

export default {
	methods: {
		onColumnSortable,
	},
	name: 'table-column-item',
	props: {
		column: {
			type: Object,
			required: true,
		},
		onCloumnSortable: {
			type: Function,
		},
	},
};
</script>



// WEBPACK FOOTER //
// TableColumnItem.vue?716b9192